
import React, {useEffect, useState} from 'react'
import {Col, Row, Form, DatePicker} from 'antd'
import {InputLabel, Title} from 'src/components/CommonStyles'
import {InputText} from "../reusables/TextInputs";
import styled from 'styled-components'
import Select from "../reusables/Select";
import Button from 'src/components/reusables/Button'
import CalendarIcon from 'src/assets/icons/CalendarIcon.svg';
import {timeSelections} from "../../constants/datetime";
import APIService from 'src/services/APIService'
import  {useOrg} from 'src/hooks/useOrgContext'
import moment from 'moment'
import { yyyyMMdd, HHMMss, plusTimezoneOffset } from 'src/helpers/datetime'
import dayjs from 'dayjs'


const CustomAvailabilityForm = ({onCancel, onSave, user, cSched}: {onCancel: () => void, onSave: () => void, user: any, cSched?: any}) => {
    const [customAvailabilityForm] = Form.useForm();

    const { put } = APIService()
    const {setCustomAvailability} = useOrg()

    useEffect(() => {
        if (cSched) {
            customAvailabilityForm.setFieldsValue({
                schedule_date: moment(cSched.schedule_date_tz).tz(user.timezone), // this fields from DB is mutated into user's current timezone set in profile
                start_time: HHMMss(cSched.start_time_tz, user.timezone), // this fields from DB is mutated into user's current timezone set in profile
                end_time: HHMMss(cSched.end_time_tz, user.timezone), // this fields from DB is mutated into user's current timezone set in profile
                notes: cSched.notes
            })
        } else {
            customAvailabilityForm.setFieldValue('start_time', '08:00:00')
            customAvailabilityForm.setFieldValue('end_time', '17:00:00')
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (cSched) {
            console.log('cSched', cSched)
            customAvailabilityForm.setFieldsValue({
                schedule_date: moment(cSched.schedule_date_tz).tz(user.timezone), // this fields from DB is mutated into user's current timezone set in profile
                start_time: HHMMss(cSched.start_time_tz, user.timezone), // this fields from DB is mutated into user's current timezone set in profile
                end_time: HHMMss(cSched.end_time_tz, user.timezone), // this fields from DB is mutated into user's current timezone set in profile
                notes: cSched.notes
            })
        }
    }, [cSched])

    const [startTime, setStartTime] = useState('08:00:00')

    const checkTimeChange = (startTime:string, endTime:string, time:string) => {
        const start:any = startTime.split(":")
        const end:any = endTime.split(":")

        function getDateTime(time:any) {
            let dateTime = new Date()
            dateTime.setHours(time[0])
            dateTime.setMinutes(time[1])
            dateTime.setSeconds(time[2])

            return dateTime
        }

        let startDateTime = getDateTime(start).getTime()
        let endDateTime = getDateTime(end).getTime()


        switch(time) {
            case 'start':
                if (startDateTime > endDateTime) {
                    // TODO: add notification invalid time
                    return false
                }
                break

            case 'end':
                if (endDateTime < startDateTime) {
                    // TODO: add notification invalid time
                    return false
                }
                break

            default:
                if (startDateTime === endDateTime) {
                    // TODO: add notification invalid time
                    return false
                }
                break
        }

        return true
    }

    const addCustomSched = async (data: any) => {
        // const reformed = {
        //     start_time: moment.tz(`${data.schedule_date}T${data.start_time}Z`, user.timezone).toISOString(),
        //     end_time: moment.tz(`${data.schedule_date}T${data.end_time}Z`, user.timezone).toISOString(),
        //     schedule_date: moment.tz(`${data.schedule_date}T00:00:00Z`, user.timezone).toISOString()
        // }
        const reformed = {
            start_time: plusTimezoneOffset(`${data.schedule_date}T${data.start_time}`, user.timezone),
            end_time: plusTimezoneOffset(`${data.schedule_date}T${data.end_time}`, user.timezone),
            schedule_date: plusTimezoneOffset(`${data.schedule_date}T00:00:00`, user.timezone)
        }


        console.log('reformed', reformed)

        if (cSched) {
            data = {...data, id: cSched.id, ...reformed}
            await put('custom-schedules/' + cSched.id , data).then((resp: any) => {
                console.log('update', resp)
                setCustomAvailability(resp)
            })
            return
        }
        await put('users/' + user.id + '/add-custom-sched', {...data, ...reformed}).then((resp: any) => {
            console.log('add', resp)
            setCustomAvailability(resp)
        })
    }

    return (
        <Form
            form={customAvailabilityForm}
            name="create-schedule-form"
            style={{width: '100%'}}
            layout={'vertical'}
            initialValues={{
                'start_time': '08:00:00',
                'end_time': '17:00:00'
            }}
            onFinish={(values) => {
                addCustomSched({...values, schedule_date: values.schedule_date.format('YYYY-MM-DD') }).then(() => onSave())
                customAvailabilityForm.resetFields()
            }}
        >
            <Title>Add Schedule</Title>
            <Row>
                <InputLabel>Select Date</InputLabel>
            </Row>
            <Form.Item
                name={'schedule_date'}
                rules={[
                    {required: true, message: 'Date is required'},
                ]}
                style={{marginBottom: '10px', textAlign: 'left'}}
            >
                <DatePicker
                    allowClear={false}
                    disabledDate={(current) => current.isBefore(moment().subtract(1,"day"))}
                    style={{width: '100%', borderRadius: 10, height: 50}}
                    onChange={(value, str) => {
                    }}
                    format={'MMMM DD, YYYY'}
                    suffixIcon={<img src={CalendarIcon} alt="calendar" />}/>
            </Form.Item>
            <Row>
                <InputLabel>Notes</InputLabel>
            </Row>
            <Form.Item
                name={'notes'}
                style={{marginBottom: '10px', textAlign: 'left'}}
            >
                <InputText name={'notes'} autoComplete='off' placeholder="Notes"
                            style={{width: '100%'}}/>
            </Form.Item>
            <Row gutter={16}>
                <Col xs={{span: 12}}>
                    <Form.Item
                        rules={[
                            {required: true, message: 'Start is required'},
                        ]}
                        style={{marginBottom: '10px'}}
                    >
                        <InputLabel>Start Time</InputLabel>
                        <Form.Item
                            name="start_time"
                            noStyle
                            normalize={(value:any, prev:any, all:any) => {
                                const endValue = customAvailabilityForm.getFieldValue('end_time')
                                return checkTimeChange(value, endValue, 'start') ? value : prev
                            }}
                        >
                            <StyledSelect
                                placeholder={'8:00 am'}
                                options={timeSelections}
                                onChange={(value: any) => {
                                    setStartTime(value)
                                }}
                                style={{margin : '5px 0px'}}
                            />

                        </Form.Item>
                    </Form.Item>
                </Col>
                <Col xs={{span: 12}}>
                    <Form.Item
                        rules={[
                            {required: true, message: 'End is required'},
                        ]}
                        style={{marginBottom: '10px'}}
                    >
                        <InputLabel>End Time</InputLabel>
                        <Form.Item
                            name="end_time"
                            noStyle
                            normalize={(value:any, prev:any, all:any) => {
                                const startValue = customAvailabilityForm.getFieldValue('end_time')
                                return checkTimeChange(startValue, value, 'end_time') ? value : prev
                            }}
                        >
                            <StyledSelect
                                placeholder={'5:00 pm'}
                                options={timeSelections.filter((timeSelection: any) => timeSelection.value > startTime)}
                                style={{margin : '5px 0px'}}
                            />
                        </Form.Item>
                    </Form.Item>
                </Col>
            </Row>
            <Form.Item
                style={{margin: '10px 0'}}
            >
                <Row gutter={16}>
                    <Col span={12}>
                        <Button
                            size={'large'}
                            style={{width: '100%', margin: 0}}
                            onClick={() => {
                                onCancel()
                                customAvailabilityForm.resetFields()
                            }}
                        >Cancel</Button>
                    </Col>
                    <Col span={12}>
                        <Button
                            htmlType={'submit'}
                            type={'primary'}
                            size={'large'}
                            style={{width: '100%', margin: 0}}
                        >Save</Button>
                    </Col>
                </Row>
            </Form.Item>
        </Form>
    )
}


export default CustomAvailabilityForm

const StyledSelect = styled(Select)<{ isrounded?: boolean}>`
  &:not(.ant-select-customize-input) {
    .ant-select-selector {
      border-radius: ${({ isrounded }) => isrounded ? '30px' : '10px'};
      height: 50px;
    }
  }

  .ant-select-selection-item {
    text-align: left;
    align-self: center;
  }

  .ant-select-selection-placeholder {
    text-align: left;
    align-self: center;
  }
`
